import QueryWhereLeftBracket from './QueryWhereLeftBracket';
import QueryWhereRightBracket from './QueryWhereRightBracket';
import QueryWhereAndOr from './QueryWhereAndOr';
import StringUtil from '../../utils/StringUtil';

export default class QueryTable
{
	remoteClass = "gongqi.erp.gotmodel.query.QueryTable";

	queryRelations;	//ArrayCollection 	//QueryRelationItem
	queryOrderBy;	//ArrayCollection	//QueryOrderByItem
	queryWhere;		//ArrayCollection	//QueryWhereItem
	queryGroupBy;	//ArrayCollection	//QueryGroupByItem
	queryAggregation;	//ArrayCollection	//QueryAggregationItem
	queryJoins;	//ArrayCollection		//QueryTable
		
	tableId;	//String
	tableName;	//String
	aliasName;	//String
	
	output;	//Boolean
	status;	//String
		
	relationJoinMode;	//String		//QueryRelationJoinMode
	relation1N;	//String			//QueryRelation1N
		
	parentProperty;	//QueryTable
	isTempTable;	//Boolean

	_sqlWhereStr;
	

	static getSqlWhereStr()
	{
		if(this._sqlWhereStr != null)
			return this._sqlWhereStr;
		var result = "";
		var leftBracket = QueryWhereLeftBracket.None;
		var rightBracket = QueryWhereRightBracket.None;
		for(let i = 0;i<this.queryWhere.length;i++)
		{
			let item = this.queryWhere[i];
			if(i > 0)
			{
				item.andOr = QueryWhereAndOr.And;
				result += (" " + QueryWhereAndOr.labelOf(item.andOr)); 
			}
			
			if(item.leftBracket != QueryWhereLeftBracket.None)
				item.leftBracket = QueryWhereLeftBracket.None;
			
			if(item.leftBracket!=QueryWhereLeftBracket.None)
			{
				result += (" " + QueryWhereLeftBracket.labelOf(item.leftBracket));
				leftBracket += item.leftBracket;
			}
			
			if(typeof(item.fieldValue) == "boolean")
			{
				item.fieldValue = item.fieldValue+"";
			}

			if(item.fieldValue == null)
				item.fieldValue = "";
			
			if(item.fieldValue && item.fieldValue.indexOf && item.fieldValue.indexOf(",") != -1)
				var fieldValues = item.fieldValue.split(",");
			else
				fieldValues = [item.fieldValue];
			
			if(fieldValues.length > 1)
				result += " (";
			
			for(let j = 0;j<fieldValues.length;j++)
			{
				let _fv = fieldValues[j];

				if(j > 0)
				{
					result += (" or " + item.fieldName+"="+"\""+_fv+"\"");	
				}
				else
				{
					result += (" "+item.fieldName+"="+"\""+_fv+"\"");
				}

				/*if(j > 0)
				{
					result += (" or " + item.fieldName+"="+StringUtil.trimThrough(_fv));	
				}
				else
				{
					result += (" "+item.fieldName+"="+StringUtil.trimThrough(_fv));
				}*/
				j++
			}
			
			if(fieldValues.length > 1)
				result += " )";
			
			if(item.rightBracket != QueryWhereRightBracket.None)
				item.rightBracket = QueryWhereRightBracket.None;
			
			if(item.rightBracket!=QueryWhereRightBracket.None)
			{
				result += (" " + QueryWhereRightBracket.labelOf(item.rightBracket));
				rightBracket += item.rightBracket;
			}
		}
		
		if(leftBracket != rightBracket)
		{
			//GongqiAlert.show("括号不匹配");
			return "";
		}
		
		this._sqlWhereStr = result;
		return result;
	}

}


// WEBPACK FOOTER //
// ./src/query/remote/QueryTable.js